import React from "react";
import { Modal, Badge, Button } from "../../components/ui";
import { formatJoinTime, getTimeInfo } from "./appointmentTime";
import "./AppointmentDetailsModal.css";

const STATUS_VARIANTS = {
  pending: "warning",
  scheduled: "primary",
  completed: "success",
  canceled: "error",
  missed: "purple",
};

function DetailRow({ label, value }) {
  return (
    <div className="detail-row">
      <span className="detail-label">{label}</span>
      <span className="detail-value">{value}</span>
    </div>
  );
}

function AppointmentDetailsModal({ appointment, now, onClose }) {
  if (!appointment) return null;

  const timeInfo = getTimeInfo(appointment, now || new Date());
  const patientName = appointment.patient?.name ?? "\u2014";
  const doctorName = appointment.doctor?.name ?? "\u2014";
  const sessionStart = formatJoinTime(appointment.date);
  const sessionEnd = formatJoinTime(appointment.endDateTime);
  const doctorJoined = formatJoinTime(appointment.doctorJoinedAt);
  const patientJoined = formatJoinTime(appointment.patientJoinedAt);
  const callStarted = formatJoinTime(appointment.callStartedAt);

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title="Appointment Details"
      size="md"
      footer={
        <div className="detail-modal-footer">
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </div>
      }
    >
      <div className="detail-body">
        <div className="detail-top-line">
          <Badge variant={STATUS_VARIANTS[appointment.status] || "default"}>
            {appointment.status}
          </Badge>
          <span className="detail-people">
            {patientName} {"\u00B7"} {doctorName}
          </span>
        </div>

        <div className="detail-grid">
          <DetailRow label="Session" value={`${sessionStart} \u2013 ${sessionEnd}`} />
          <DetailRow label="Doctor joined" value={doctorJoined} />
          <DetailRow label="Patient joined" value={patientJoined} />
          <DetailRow label="Call started" value={callStarted} />
        </div>

        <div className={`detail-countdown detail-countdown-${timeInfo.tone}`}>
          {timeInfo.label}
        </div>
      </div>
    </Modal>
  );
}

export default AppointmentDetailsModal;